import { Route, Routes } from "react-router-dom";
import { AnalystAssignment } from "./list";

export default function AnalystAssignmentRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AnalystAssignment />} />
      <Route path="/edit" element={<p>Editar atribuições</p>} />
    </Routes>
  );
}
